import { InjectionToken } from '@angular/core'

export const RedirectToken = new InjectionToken<string>('redirect_url')
export const LoginPageRegex = new InjectionToken<RegExp>('login_regex_token')
